/**
 * Staff tooling access: the role check the desktop sidebar's Admin link, the
 * phone tab bar's Admin tab and the More sheet's Order row all share (#2142).
 */
export function isStaffRole(role: string | undefined | null) {
  return role === 'admin' || role === 'staff';
}
